const stylesC = {
  containChat: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 'auto',
    width: '100%',
    padding: '5px',
    border: 'none',
    borderRadius: '5px',
    margin: '3px 0px',
    cursor: 'pointer',
  },
  containChatSel: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 'auto',
    width: '100%',
    padding: '5px',
    border: 'none',
    backgroundColor: '#d9d9d9',
    margin: '0px',
    cursor: 'pointer',
  },
  containChatMNL: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 'auto',
    width: '100%',
    padding: '5px',
    border: 'none',

    margin: '3px 0px',
    cursor: 'pointer',
    backgroundColor: 'white',
    animation: 'simple-blink 3s infinite',
    '@keyframes simple-blink': {
      '0%': {
        backgroundColor: 'white',
      },
      '50%': {
        backgroundColor: '#d9d9d9',
      },
      '100%': {
        backgroundColor: 'white',
      },
    },
  },
  containHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: 'auto',
    width: 'auto',
    padding: '5px',
  },
  containAvatar: {
    width: '50px',
    height: '50px',
    borderRadius: '50%',
    marginRight: '-5px',
    objectFit: 'cover',
  },
  titleComp: {
    fontSize: '16px',
    fontWeight: 'bold',
  },
  labelComp: {
    fontSize: '14px',
    color: 'gray',
  },
  labelComPedido: {
    fontSize: '14px',

    whiteSpace: 'nowrap',
    fontWeight: 'bold',
  },
  containLabel: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: 'auto',
    width: '100%',
  },
  containPedido: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: 'auto',
    width: '40%',
    padding: '5px',
    border: '1px solid #ccc',
    borderRadius: '5px',
  },
}

export default stylesC
